import React from 'react';
import {
  DataGridCellTypes,
  DataGridCellBaseProps,
} from '../../DataGridCell.types';
import {
  DataGridCustomCell,
  DataGridTagCell,
  DataGridTextCell,
  DataGridExpandedCell,
  DataGridLinkCell,
  DataGridCheckboxCell,
} from '../../cells';

const Cells: Record<DataGridCellTypes, Function> = {
  TAG: DataGridTagCell,
  TEXT: DataGridTextCell,
  CUSTOM: DataGridCustomCell,
  EXPANDED: DataGridExpandedCell,
  LINK: DataGridLinkCell,
  CHECK: DataGridCheckboxCell,
};

const DefaultCell = Cells['TEXT'];

export type DataGridCellWrapperProps = {
  type?: DataGridCellTypes;
} & DataGridCellBaseProps;
export const DataGridCellWrapper: React.FC<DataGridCellWrapperProps> = ({
  type,
  data,
  ...props
}) => {
  if (type) {
    const Cell = Cells[type];

    if (Cell) return <Cell data={data} {...props} />;
  }

  return <DefaultCell data={data} {...props} />;
};
